import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FakturaForm from './FakturaForm';
import LeveringForm from './LeveringForm';
import { Col, Row } from '../../../components/grid';
import {
  ConnectedDeliveryAndPickup,
  ConnectedFree,
  ConnectedNo,
} from '../Levering/LeveringsTypeForm';
import deliveryCloser from '../Levering/LeveringComponenter/deliveryCloser';
import { deliveryTypes } from '../../../features/commerce';
import { hasFustagerWithoutAnlaeg, hasAnlaegWithoutIs, hasAnlaegWithoutGlass } from '../../../features/commerce/selectors';
import { Bucket } from '../../../containers/commerce';
import { RecieptView } from '../../../components/commerce/Bucket';
import GodkendOrdre from './GodkendOrdre';
import DeliveryOptionStep2 from '../Levering/LeveringComponenter/DeliveryOptionStep2';
import AnlaegModal from '../../../components/AnlaegModal';
import AnlaegNoIsModal from '../../../components/AnlaegNoIsOrGlassModal';
import Title from './Title';

const DeliveryAndPickup = deliveryCloser(deliveryTypes.deliveryAndPickup)(ConnectedDeliveryAndPickup);
const Free = deliveryCloser(deliveryTypes.delivery)(ConnectedFree);
const No = deliveryCloser(deliveryTypes.no)(ConnectedNo);

const LeveringsWrap = styled(({ children, ...props }) => <div {...props}>{children}</div>)`
  border-top: 0px solid ${({ theme }) => theme.colors.colorBlue};
`;

class Detaljer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDerived: false,
      fustagerWithoutAnlaegIsOpen: false,
      anlaegWithoutIsOrGlassOpen: false,
    };
    this.onRedirectFustagerNoAnlaeg = this.onRedirectFustagerNoAnlaeg.bind(this);
    this.onRedirectAnlaegNoIs = this.onRedirectAnlaegNoIs.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
  }

  onRedirectFustagerNoAnlaeg() {
    const {
      history: {
        push,
      },
    } = this.props;
    push('/bestil/fadoel-og-anlaeg/anlaeg-og-bar');
  }

  onRedirectAnlaegNoIs() {
    const {
      history: {
        push,
      },
    } = this.props;
    push('/bestil/fadoel-og-anlaeg/oelglas/kategori/is/vare/50025');
  }

  onModalClose() {
    this.setState({ fustagerWithoutAnlaegIsOpen: false, anlaegWithoutIsOrGlassOpen: false });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      hasDerived,
    } = prevState;
    const {
      fustagerWithoutAnlaeg,
      anlaegWithoutIs,
      anlaegWithoutGlass,
    } = nextProps;
    if (fustagerWithoutAnlaeg && !hasDerived) {
      return {
        hasDerived: true,
        fustagerWithoutAnlaegIsOpen: true,
      };
    }
    if ((anlaegWithoutIs || anlaegWithoutGlass)&& !hasDerived) {
      return {
        hasDerived: true,
        anlaegWithoutIsOrGlassOpen: true,
      };
    }
    return {};
  }

  render() {
    const {
      anlaegWithoutIs,
      anlaegWithoutGlass,
    } = this.props;
    const { fustagerWithoutAnlaegIsOpen, anlaegWithoutIsOrGlassOpen } = this.state;
    return (
      <React.Fragment>
        <AnlaegModal
          isOpen={fustagerWithoutAnlaegIsOpen}
          onRedirect={this.onRedirectFustagerNoAnlaeg}
          onClose={this.onModalClose}
        />
        <AnlaegNoIsModal
          isOpen={anlaegWithoutIsOrGlassOpen}
          hasIs={!anlaegWithoutIs}
          hasGlass={!anlaegWithoutGlass}
          onRedirect={this.onRedirectAnlaegNoIs}
          onClose={this.onModalClose}
        />
        <Row>
          <Col xs={12} paddingTop="0px" paddingBottom="0px">
            <Bucket display={RecieptView} />
          </Col>
          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
            <Title number="1" text="Kundeoplysninger" />
            <FakturaForm />
            <LeveringForm />
          </Col>
          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
            <Title number="2" text="Leveringsmetode" />
            <LeveringsWrap>
              <No heightWhenHidden="140px" deliveryOptionComponent={DeliveryOptionStep2} step2 />
              <DeliveryAndPickup heightWhenHidden="140px" deliveryOptionComponent={DeliveryOptionStep2} step2 />
              <Free heightWhenHidden="140px" deliveryOptionComponent={DeliveryOptionStep2} step2 />
            </LeveringsWrap>
          </Col>
          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
            <Title number="3" text="Betaling" />
            <Bucket display={GodkendOrdre} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      fustagerWithoutAnlaeg: hasFustagerWithoutAnlaeg(state),
      anlaegWithoutIs: hasAnlaegWithoutIs(state),
      anlaegWithoutGlass: hasAnlaegWithoutGlass(state),
    }),
  )(Detaljer),
);
